import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  completed(codeLang: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/completed`, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }

  skip(codeLang: string) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/skip`, {}, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }

  getQuestion(codeLang: string, uniqid?: string) {
    let url = `${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/questions`;
    if (uniqid) {
      url += `/${uniqid}`;
    }
    return this.http.get(url, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }

  answer(codeLang: string, values: any) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/answer`, values, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }

  affect(codeLang: string) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/affect`, {}, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }

  history(codeLang: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint(codeLang)}evaluation/history`, {
      headers: new HttpHeaders({
        Platform: codeLang
      })
    }).toPromise();
  }
}
